var _rect, _ellipse, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVenn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 66,
    height: 66,
    rx: 8,
    fill: "#CF112D"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 32.8804,
    cy: 32.9983,
    rx: 6.70539,
    ry: 12.6657,
    fill: "#FAFAFA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.5418 43.4357C25.8218 43.6071 25.0582 43.7143 24.2727 43.7143C18.2509 43.7143 13.3636 38.9143 13.3636 33C13.3636 27.0857 18.2509 22.2857 24.2727 22.2857C25.0582 22.2857 25.8218 22.3929 26.5418 22.5643C27.3927 21.3643 28.4618 20.1643 29.7927 19.0714C28.0909 18.4071 26.2364 18 24.2727 18C15.8509 18 9 24.7286 9 33C9 41.2714 15.8509 48 24.2727 48C26.2364 48 28.0909 47.5929 29.7927 46.9286C28.4618 45.8357 27.3927 44.6357 26.5418 43.4357ZM41.7273 18C39.7636 18 37.9091 18.4071 36.2073 19.0714C37.5382 20.1643 38.6073 21.3643 39.4582 22.5643C40.1782 22.3929 40.9418 22.2857 41.7273 22.2857C47.7491 22.2857 52.6364 27.0857 52.6364 33C52.6364 38.9143 47.7491 43.7143 41.7273 43.7143C40.9418 43.7143 40.1782 43.6071 39.4582 43.4357C38.6073 44.6357 37.5382 45.8357 36.2073 46.9286C37.9091 47.5929 39.7636 48 41.7273 48C50.1491 48 57 41.2714 57 33C57 24.7286 50.1491 18 41.7273 18Z",
    fill: "#FAFAFA"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVenn);
export default __webpack_public_path__ + "static/media/venn.a058bc19562b3da5125aab24e4e0db3a.svg";
export { ForwardRef as ReactComponent };